/* Corinne product cleanup helpers - SAFE VERSION
   This version avoids hiding large product containers.
*/
(function () {
  function normalize(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function includesText(value, phrase) {
    return normalize(value).indexOf(normalize(phrase)) !== -1;
  }

  function hideElement(element) {
    if (!element || element === document.body || element === document.documentElement) return;
    element.classList.add('corinne-hidden-product-block');
    element.setAttribute('aria-hidden', 'true');
  }

  function isProductPage() {
    return document.body.className.indexOf('template-product') !== -1 || Boolean(document.querySelector('form[action*="/cart/add"]'));
  }

  function hideProductShareAndPinterest() {
    document.querySelectorAll([
      '.share-button',
      '.product__share',
      '.product-share',
      '.social-sharing',
      '[class*="share-button"]',
      '[class*="product-share"]',
      'a[href*="pinterest.com"]',
      'a[href*="pinterest."]'
    ].join(',')).forEach(function (element) {
      var wrapper = element.closest('li') || element;
      hideElement(wrapper);
    });
  }

  function hideExactProductOptions() {
    if (!isProductPage()) return;

    document.querySelectorAll('fieldset, .product-form__input, .selector-wrapper, .variant-wrapper, .line-item-property__field, .shopify-block').forEach(function (block) {
      var labelText = '';
      var legend = block.querySelector('legend');
      var label = block.querySelector('label');
      var heading = block.querySelector('h2,h3,h4');

      labelText = [
        legend ? legend.textContent : '',
        label ? label.textContent : '',
        heading ? heading.textContent : '',
        block.getAttribute('data-name') || '',
        block.getAttribute('data-option-name') || ''
      ].join(' ');

      var text = normalize(labelText);
      if (
        text.indexOf('personalizare produs') !== -1 ||
        text.indexOf('personalizare produs litere si cifre') !== -1 ||
        text.indexOf('impachetare cadou') !== -1 ||
        text.indexOf('ambalare cadou') !== -1 ||
        text.indexOf('gift wrap') !== -1 ||
        text.indexOf('gift wrapping') !== -1
      ) {
        hideElement(block);
      }
    });

    document.querySelectorAll('input, select, textarea').forEach(function (field) {
      var nameText = [
        field.name || '',
        field.id || '',
        field.getAttribute('aria-label') || '',
        field.getAttribute('placeholder') || ''
      ].join(' ');

      var text = normalize(nameText);
      if (
        text.indexOf('personalizare produs') !== -1 ||
        text.indexOf('personalizare') !== -1 ||
        text.indexOf('impachetare cadou') !== -1 ||
        text.indexOf('ambalare cadou') !== -1 ||
        text.indexOf('gift') !== -1
      ) {
        hideElement(field.closest('.product-form__input, fieldset, .line-item-property__field, .shopify-block, .selector-wrapper') || field);
      }
    });
  }

  function hideDescriptionSections() {
    if (!isProductPage()) return;

    var descriptions = document.querySelectorAll('.product__description, [class*="product__description"], .rte');
    descriptions.forEach(function (description) {
      var children = Array.prototype.slice.call(description.children || []);

      children.forEach(function (child, index) {
        var headingText = normalize(child.textContent || '');
        var isHeading = /^H[1-6]$/.test(child.tagName || '') || child.matches('strong, b');

        var shouldHideSection = isHeading && (
          headingText === 'marimi si culori' ||
          headingText === 'mărimi și culori' ||
          headingText.indexOf('marimi si culori') !== -1 ||
          headingText.indexOf('personalizeaza produsul') !== -1 ||
          headingText.indexOf('personalizează produsul') !== -1
        );

        if (!shouldHideSection) return;

        hideElement(child);

        for (var i = index + 1; i < children.length; i += 1) {
          var next = children[i];
          if (/^H[1-6]$/.test(next.tagName || '')) break;
          hideElement(next);
        }
      });
    });
  }

  function hideColorGuideMedia() {
    if (!isProductPage()) return;

    var phrases = [
      'alb albastru',
      'alb/albastru',
      'alb-albastru',
      'mai multe culori',
      'multiple culori',
      'culori disponibile',
      'paletar culori',
      'paletar de culori'
    ];

    document.querySelectorAll('img').forEach(function (image) {
      var haystack = [
        image.getAttribute('alt'),
        image.getAttribute('src'),
        image.currentSrc,
        image.getAttribute('data-src')
      ].join(' ');

      var found = phrases.some(function (phrase) { return includesText(haystack, phrase); });
      if (!found) return;

      var mediaBlock = image.closest('.product__media-item, .thumbnail-list__item, .product-media-modal__content > *, .swiper-slide, li') || image;
      mediaBlock.classList.add('corinne-hidden-product-media');
      mediaBlock.setAttribute('aria-hidden', 'true');
    });
  }

  function runCleanup() {
    hideProductShareAndPinterest();
    hideExactProductOptions();
    hideDescriptionSections();
    hideColorGuideMedia();
  }

  document.addEventListener('DOMContentLoaded', function () {
    runCleanup();
    window.setTimeout(runCleanup, 500);
    window.setTimeout(runCleanup, 1500);
  });
})();
